import { useNavigation, usePreventRemove } from '@react-navigation/native';
import { confirmer } from '../utils/confirmation';

/**
 * Confirme avant de quitter un écran qui affiche un résultat NON PERSISTÉ.
 *
 * `usePreventRemove` intercepte l'action de retour elle-même : la garde couvre donc le bouton
 * « précédent » ET le balayage, pas seulement le geste. C'est le point important — protéger le seul
 * geste rendrait le bouton plus destructeur que lui.
 *
 * Le passage du balayage en plein écran transforme un risque rare (viser un bouton de 44 points)
 * en risque quotidien (un glissement horizontal n'importe où), sur un résultat qui a consommé
 * l'unique analyse mensuelle d'un compte Free.
 *
 * Le hook doit être appelé DANS l'arbre d'un écran de pile : il vit donc dans la couche navigation,
 * pas dans les écrans, qui restent testables isolément.
 */
export function useDiscardGuard(dirty: boolean, message: string): void {
  const navigation = useNavigation();

  usePreventRemove(dirty, ({ data }) => {
    confirmer('Quitter cette analyse ?', message, [
      { text: 'Rester', style: 'cancel' },
      // Libellé explicite : c'est la sortie qui détruit, pas le fait de rester.
      { text: 'Quitter et perdre', style: 'destructive', onPress: () => navigation.dispatch(data.action) },
    ]);
  });
}
